import { jsPDF } from "jspdf";

export const buildJoinUrl = (slug, programId) =>
  `${window.location.origin}/join/${slug}${programId ? `?program=${programId}` : ""}`;

// Download a QR canvas (inside a container ref) as a PNG file.
export function downloadCanvasPng(container, filename) {
  const canvas = container?.querySelector("canvas");
  if (!canvas) return;
  const url = canvas.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.png`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function getCanvasDataUrl(container) {
  const canvas = container?.querySelector("canvas");
  return canvas ? canvas.toDataURL("image/png") : "";
}

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}

const cardHtml = ({ shopName, logoUrl, program, qrDataUrl }) => {
  const goalLine = program.goal
    ? `Collect ${program.goal} ${program.earn_type === "stamps" ? "stamps" : "points"} to earn:`
    : "";
  return `<!doctype html><html><head><meta charset="utf-8"><title>${shopName} — ${program.title}</title>
  <style>
    *{box-sizing:border-box;margin:0;padding:0}
    body{font-family:'Helvetica Neue',Arial,sans-serif;background:#fff;color:#111;display:flex;align-items:center;justify-content:center;padding:24px}
    .card{width:340px;border:2px solid #111;padding:26px 24px;text-align:center}
    .accent{height:8px;background:${program.accent || "#0033A0"};margin:-26px -24px 20px}
    .logo{max-height:52px;max-width:180px;margin:0 auto 10px;display:block}
    .shop{font-size:13px;letter-spacing:.14em;text-transform:uppercase;color:#666;font-weight:700}
    .title{font-size:24px;font-weight:800;margin:10px 0 4px;letter-spacing:-.02em}
    .reward{font-size:15px;color:${program.accent || "#0033A0"};font-weight:700}
    .goal{font-size:12px;color:#666;margin-top:6px}
    .qr{margin:18px auto 8px;width:200px;height:200px}
    .qr img{width:100%;height:100%}
    .scan{font-size:14px;font-weight:700}
    .sub{font-size:11px;color:#888;margin-top:4px}
    @media print{body{padding:0}}
  </style></head><body onload="window.focus();window.print();">
    <div class="card">
      <div class="accent"></div>
      ${logoUrl ? `<img class="logo" src="${logoUrl}" alt="">` : ""}
      <div class="shop">${shopName}</div>
      <div class="title">${program.title || "Rewards"}</div>
      ${program.reward ? `<div class="reward">${program.reward}</div>` : ""}
      ${goalLine ? `<div class="goal">${goalLine}</div>` : ""}
      <div class="qr"><img src="${qrDataUrl}" alt="QR code"></div>
      <div class="scan">Scan to join</div>
      <div class="sub">Point your phone camera at the code</div>
    </div>
  </body></html>`;
};

export function printLoyaltyCard(opts) {
  const w = window.open("", "_blank", "width=420,height=680");
  if (!w) return;
  w.document.write(cardHtml(opts));
  w.document.close();
}

export async function downloadLoyaltyCardPdf({ shopName, logoUrl, program, qrDataUrl }) {
  const doc = new jsPDF({ unit: "pt", format: [280, 400] });
  const W = 280;
  const accent = program.accent || "#0033A0";
  // accent bar
  const rgb = hexToRgb(accent);
  doc.setFillColor(rgb.r, rgb.g, rgb.b);
  doc.rect(0, 0, W, 10, "F");
  // border
  doc.setDrawColor(17, 17, 17);
  doc.setLineWidth(1.5);
  doc.rect(16, 24, W - 32, 360);

  let y = 48;
  if (logoUrl) {
    try {
      const img = await loadImage(logoUrl);
      const ratio = img.width / img.height;
      const lh = 40, lw = Math.min(150, lh * ratio);
      doc.addImage(img, "PNG", (W - lw) / 2, y, lw, lh);
      y += lh + 12;
    } catch (e) { /* skip logo */ }
  }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9); doc.setTextColor(100);
  doc.text((shopName || "").toUpperCase(), W / 2, y, { align: "center" });
  y += 22;
  doc.setFontSize(20); doc.setTextColor(17);
  doc.text(program.title || "Rewards", W / 2, y, { align: "center", maxWidth: W - 48 });
  y += 20;
  if (program.reward) {
    doc.setFontSize(12); doc.setTextColor(rgb.r, rgb.g, rgb.b);
    doc.text(program.reward, W / 2, y, { align: "center", maxWidth: W - 48 });
    y += 16;
  }
  if (program.goal) {
    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(120);
    doc.text(`Collect ${program.goal} ${program.earn_type === "stamps" ? "stamps" : "points"} to earn`, W / 2, y, { align: "center" });
    y += 12;
  }
  if (qrDataUrl) {
    const qs = 150;
    doc.addImage(qrDataUrl, "PNG", (W - qs) / 2, y + 6, qs, qs);
    y += qs + 22;
  }
  doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.setTextColor(17);
  doc.text("Scan to join", W / 2, y, { align: "center" });

  doc.save(`${(program.title || "loyalty").replace(/\s+/g, "-")}-card.pdf`);
}

function hexToRgb(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "#0033A0");
  return m ? { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) } : { r: 0, g: 51, b: 160 };
}
